import React from 'react';
import { CROP_WIDTH, CROP_HEIGHT } from '~/config/constants';
import PreviewAsImg from '~/components/FileUploaded/picture-preview/PreviewAsImg';
import withCustomPreview, { useWithCustomPreviewContext } from '~/components/FileUploaded/withCustomPreview';
import { formLabel } from '~/utils/helpers';
import { useField } from 'formik';
import { FormFeedback } from '~/components/FormControl';
import isEmpty from 'lodash/isEmpty';

const IconOrCropWithHOC = () => {
    const { pictureUrl, inputEl, wrapperStyle, wrapperClass, pictureName } = useWithCustomPreviewContext();
    const [, meta] = useField(pictureName);

    return (
        <>
            <PreviewAsImg
                pictureUrl={pictureUrl}
                inputEl={inputEl}
                id={pictureName}
                width={CROP_WIDTH}
                height={CROP_HEIGHT}
                wrapperClass={wrapperClass}
                wrapperStyle={wrapperStyle}
            />
            <figcaption>{formLabel(pictureName)}</figcaption>
            <FormFeedback
                isInvalid={!isEmpty(meta.error) && meta.touched}
                errorMessage={meta.error}
                className={'text-center'}
            />
        </>
    );
};

export default withCustomPreview(IconOrCropWithHOC);
